import { Profile } from 'oidc-client';
import { VerificationVm } from '../../../utils/api';
import VerificationTable from './VerificationTable';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../../core/models/RouteParams';

interface OwnProps {
    wrappedComponentRef?: any;
    userProfile: Profile;
    verifications?: VerificationVm[];
    onUpdate: (id: number) => void;
    onDelete: (id: number) => Promise<void>;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(VerificationTable);
